import { render, staticRenderFns } from "./AccLeave.vue?vue&type=template&id=70518005&scoped=true&"
import script from "./AccLeave.vue?vue&type=script&lang=js&"
export * from "./AccLeave.vue?vue&type=script&lang=js&"
import style0 from "./AccLeave.vue?vue&type=style&index=0&id=70518005&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70518005",
  null
  
)

export default component.exports